import { STATUS_FILTERS, STATUS_META } from './couponAdapter';

const BADGE = {
  active: { pill: 'bg-status-ok-bg text-status-ok-text border-status-ok-border', dot: 'bg-status-ok-dot' },
  draft: { pill: 'bg-surface-container text-on-surface border-outline-variant/40', dot: 'bg-outline' },
  archived: { pill: 'bg-surface-container-low text-on-surface-variant/80 border-outline-variant/30', dot: 'bg-outline-variant' },
};

/** Active (green) / Draft (grey) / Archived (muted) pill. */
export function PackageStatusBadge({ status }) {
  const style = BADGE[status] ?? BADGE.draft;
  return (
    <span className={`inline-flex items-center gap-1.5 h-[22px] px-2 rounded-full border text-[11px] font-semibold whitespace-nowrap ${style.pill}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} aria-hidden="true" />
      {STATUS_META[status]?.label ?? status}
    </span>
  );
}

const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('en-US') : '…');

/** All / Active / Draft / Archived chips with counts; a single-choice radio group. */
export function StatusFilterChips({ value, counts, onChange }) {
  return (
    <div role="radiogroup" aria-label="Filter by status" className="flex flex-wrap gap-1.5">
      {STATUS_FILTERS.map((s) => {
        const active = value === s.key;
        return (
          <button
            key={s.key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => !active && onChange(s.key)}
            className={`h-8 px-3 rounded-full text-xs font-semibold inline-flex items-center gap-1.5 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-status-ok-dot focus-visible:ring-offset-1 ${
              active ? 'bg-primary text-on-primary' : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container hover:text-on-surface'
            }`}
          >
            {s.label}{' '}
            <span className={`font-data-mono text-[10px] ${active ? 'text-on-primary-container' : ''}`}>({fmt(counts?.[s.key])})</span>
          </button>
        );
      })}
    </div>
  );
}
